import { AttributesMixin, define, Model} from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";


export interface ImportJobReprocessor extends AttributesMixin<typeof ImportJobReprocessor> { }
@define
export class ImportJobReprocessor extends Model {
    static endpoint = restfulIO('api/v1/ingest/import-jobs');

    static attributes = {
        status: String
    }

    async do(id: Number): Promise<Response> {
      const url = `api/v1/ingest/import-jobs/${id}/reprocess`;

      return await fetch(url, {
        method: 'PUT',
        headers: new Headers({
          "Authorization": getAuthorizationBearer(),
          'X-Platform-Code': getPlatformCode()
        }),
      });
    }
}
